export const ACTIVATE_CREDIT_CARD_START =
  'ACTIVATE_CREDIT_CARD_START';
export const ACTIVATE_CREDIT_CARD_SUCCESS =
  'ACTIVATE_CREDIT_CARD_SUCCESS';
export const ACTIVATE_CREDIT_CARD_ERROR =
  'ACTIVATE_CREDIT_CARD_ERROR';
export const CLEAR_ACTIVATE_CREDIT_CARD_STORE =
  'CLEAR_ACTIVATE_CREDIT_CARD_STORE';
